﻿import { registerBookingLink } from '../widgets/booking-link/booking-link';

registerBookingLink();
